import { LOCALES } from '../../constants';

const SPANISH = {
  [LOCALES.SPANISH]: {
    //GLOBAL
    currencyFormat: 'EUR',
    totalSales: 'Total de ventas',
    totalPercentageProfit: 'Total porcentaje beneficio',
    totalValueProfit: 'Total valor beneficio',
    totalPositivation: 'Total positivización',
    totalPositivationMix: 'Total positivización mix',
    title: 'Titulo',
    message: 'Mensaje',
    description: 'Descripción',
    dateCreation: 'Dt.creación',
    view: 'Vista',
    //TESTE
    hello: 'Hola',
    dashboard: 'Dashboard es-ES',
    //WEEKDAY
    weekDayMonday: 'LUN',
    weekDayTuesday: 'MAR',
    weekDayWednesday: 'MIE',
    weekDayThursday: 'JUE',
    weekDayFriday: 'VIE',
    weekDaySaturday: 'SAB',
    weekDaySunday: 'DOM',
    //COMMON
    commonTableHeaderLabelActions: 'Comparte',
    commonTablePaginationLabelRowsPerPage: 'Líneas por página',
    commonAppbarMenuProfile: 'Perfil del usuario',
    commonAppbarMenuLogout: 'Salir',
    commonInputSearch: 'Buscar ...',
    commonLoadingMessage: 'Cargando...',
    commonSavingMessage: 'Salvando ...',
    commonSendMessage: 'Enviando...',
    commonWaitingMessage: 'Esperar...',
    commonErrorMessage: 'Hubo un error en tu solicitud',
    commonAutocompleteSelectPlaceholder: 'Seleccione...',
    commonButtonAddImage: 'Para agregar',
    commonButtonRemoverImage: 'Para eliminar',
    commonButtonReturn: 'Regreso',
    commonLabelDelete: 'Borrar',
    commonLabelEdit: 'Editar',
    commonLabelMinimize: 'Minimizar',
    commonLabelYes: 'Sí',
    commonLabelNo: 'No',
    commonAutocompleteSelectNoOptions: 'Sin opciones',
    //SIDEBAR
    sidebarMenuItemDashboard: 'Tablero',
    sidebarMenuItemEngine: 'Motor de ventas',
    sidebarMenuItemRewards: 'Recompensas',
    sidebarMenuItemTrading: 'Motor comercial',
    sidebarMenuItemSponsored: 'Patrocinados',
    sidebarMenuItemAccess: 'Acceso',
    sidebarMenuItemUser: 'Usuarios',
    sidebarMenuItemUserGroup: 'Veces',
    sidebarMenuItemNotification: 'Notificaciones',
    sidebarMenuItemOrder: 'Mis pedidos',
    sidebarMenuItemConfiguration: 'ajustes',
    //LOGIN
    loginTitle: 'Acceso',
    loginInputPassword: 'Contraseña',
    loginInputUsername: 'Acceso',
    loginLabelRememberMe: 'Recuérdame en este dispositivo',
    loginLabelResetPassword: 'Olvide mi contraseña',
    loginButtonSubmit: 'Entra',
    loginLabelTitle: 'Acceso',
    loginLabelSubtitle: 'Ingrese sus datos a continuación',
    loginLabelDevelopment: 'Desarrollado por',
    loginLabelVersion: 'Versión',
    loginMessageError: '¡El nombre de usuario o la contraseña no son válidos! ',
    loginMesageLoading: 'Autenticando, por favor espere ... .',
    loginMessageSuccess: '¡Inicie sesión con éxito! ',
    //RESET-PASSWORD
    resetPasswordTitle: 'Olvide mi contraseña',
    resetPasswordInputEmail: 'Correo electrónico',
    resetPasswordLabelTitle: 'Olvidaste tu contraseña?',
    resetPasswordButtonSubmit: 'Enviar petición',
    resetPasswordButtonBack: 'Regresar',
    resetPasswordLabelSubtitle:
      'Ingrese la dirección de correo electrónico asociada con su cuenta y le enviaremos un correo electrónico para restablecer su contraseña.',
    resetPasswordSuccessTitle: 'email enviado con éxito',
    resetPasswordSuccessSubtitle:
      'Enviamos un correo electrónico de confirmación a {correo electrónico}.Por favor revise su correo electrónico.',
    resetPasswordLabelDevelopment: 'Desarrollado por',
    resetPasswordLabelVersion: 'Versión',
    resetPasswordMessageError: '¡Introduzca una dirección de correo electrónico válida! ',
    //USER-LIST
    userListTitle: 'Usuarios',
    userListButtonAdd: 'Nuevo Usuario',
    userListTableHeaderExternalCode: 'Código',
    userListTableHeaderName: 'Nombre',
    userListTableHeaderEmail: 'Correo electrónico',
    userListTableHeaderUserRole: 'Ocupación',
    userListTableHeaderCreatedAt: 'Dt.creación',
    userListTableHeaderUpdatedAt: 'Dt.actualizar',
    //USER-FORM
    userFormTitle: 'Registro de usuario',
    userFormButtonEdit: 'Usuario de actualización',
    userFormButtonNew: 'Crear usuario',
    userFormLabelExternalCode: 'Código',
    userFormLabelNickname: 'Apellido',
    userFormLabelName: 'Nombre completo',
    userFormLabelUserRole: 'Carga',
    userFormLabelSuperiorExternalCode: 'Supervisor',
    userFormLabelEmail: 'Correo electrónico',
    userFormLabelPassword: 'Contraseña',
    userFormLabelPasswordConfirm: 'confirme la contraseña',
    userFormLabelUserSubsidiaries: 'Sucursales',
    userFormLabelInactive: 'Inactivo',
    userFormMessageRequiredName: 'El nombre es obligatorio',
    userFormMessageRequiredNickname: 'Se requiere apodo',
    userFormMessageRequiredUserRole: 'El cargo es obligatorio',
    userFormMessageRequiredExternalCode: 'Se requiere código',
    userFormMessageRequiredApproveDiscount: 'Se requiere grupo de versión',
    userFormMessageApproveDiscountNotVendor: 'El grupo de lanzamiento es solo para usuarios con rol de vendedor.',
    userFormMessageValidEmail: 'Introduzca una dirección de correo electrónico válida',
    userFormMessageRequiredEmail: 'El correo electrónico es obligatorio',
    userFormMessageRequiredUserSubsidiaries: 'La filial es obligatoria',
    userFormMessageMinPassword: 'La contraseña debe tener al menos 6 caracteres.',
    userFormMessageRequiredPassword: 'se requiere contraseña',
    userFormMessageRequiredMatchPassword: 'La confirmación de la contraseña es obligatoria.',
    userFormMessageMatchPassword: 'La contraseña debe ser igual',
    userFormMessageLastSync: 'Última sincronización: {lastTimestamp} - Versión de la aplicación: {appVersion}',
    userFormLiberationGroup: 'Grupo de liberación de pedidos',

    //TEAM-LIST
    teamListTitle: 'Veces',
    teamListButtonAdd: 'Nuevo equipo',
    teamListTableHeaderId: 'IDENTIFICACIÓN',
    teamListTableHeaderName: 'Nombre',
    teamListTableHeaderDescription: 'Descripción',
    teamListTableHeaderCreatedAt: 'Dt.creación',
    teamListTableHeaderUpdatedAt: 'Dt.actualizar',
    //TEAM-FORM
    teamFormTitle: 'Registro de equipo',
    teamFormButtonEdit: 'Tiempo de actualizacion',
    teamFormButtonNew: 'Crear equipo',
    teamFormLabelName: 'Nombre',
    teamFormLabelDescription: 'Descripción',
    teamFormLabelUsers: 'Usuarios',
    teamFormMessageRequiredName: 'El nombre es obligatorio',
    teamFormMessageRequiredDescription: 'La descripción es obligatoria',
    teamFoemMessageMinUsers: 'Se requieren usuarios',
    //REWARDS-LIST
    rewardsListTitle: 'Recompensas',
    rewardsListButtonAdd: 'nuevarecompensa',
    rewardsListTableHeaderId: 'IDENTIFICACIÓN',
    rewardsListTableHeaderLabel: 'Nombre',
    rewardsListTableHeaderDescription: 'Descripción',
    rewardsListTableHeaderPrice: 'Precio',
    rewardsListTableHeaderRequiredPoints: 'Lugares',
    rewardsListTableHeaderCreatedAt: 'Dt.creación',
    rewardsListTableHeaderUpdatedAt: 'Dt.actualizar',
    //REWARDS-FORM
    rewardsFormTitle: 'Registro de recompensa',
    rewardsFormButtonEdit: 'Recompensa de recompensa',
    rewardsFormButtonNew: 'Recompensa',
    rewardsFormLabelLabel: 'Nombre',
    rewardsFormLabelDescription: 'Descripción',
    rewardsFormLabelPrice: 'Precio',
    rewardsFormLabelRequiredPoints: 'Lugares',
    rewardsFormLabelQuantity: 'Cantidad',
    rewardsMessageRequiredLabel: 'El nombre es obligatorio',
    rewardsMessageRequiredDescription: 'La descripción es obligatoria',
    rewardsMessageMinPrice: 'Precio incorrecto',
    rewardsMessageRequiredPrice: 'El precio es obligatorio',
    rewardsMessageMinRequiredPoints: 'Incorrecto',
    rewardsMessageRequiredRequiredPoints: 'Los puntos son obligatorios',
    rewardsMessageMinQuantity: 'Cantidad incorrecta',
    rewardsMessageRequiredQuantity: 'La cantidad es obligatoria',
    //SPONSORED-LIST
    sponsoredListTitle: 'Productos patrocinados',
    sponsoredListButtonAdd: 'Nuevo producto',
    sponsoredListTableHeaderId: 'IDENTIFICACIÓN',
    sponsoredListTableHeaderProductExternalCode: 'Código. Producto',
    sponsoredListTableHeaderProductName: 'Nombre',
    sponsoredListTableHeaderDescription: 'Descripción',
    sponsoredListTableHeaderPointsMultiplier: 'Multiplicador',
    sponsoredListTableHeaderStartDate: 'Dt.ingenioso',
    sponsoredListTableHeaderEndData: 'Dt.final',
    sponsoredStatusExpired: 'Caducado',
    sponsoredStatusValid: 'Válido',
    //SPONSORED-FORM
    sponsoredFormTitle: 'Registro patrocinado del producto',
    sponsoredFormButtonEdit: 'Actualizar producto',
    sponsoredFormButtonNew: 'Crear producto',
    sponsoredFormLabelStarDate: 'La fecha de inicio',
    sponsoredFormLabelEndDate: 'Final de datos',
    sponsoredFormLabelDescription: 'Descripción Beneficio / Premio',
    sponsoredFormLabelPointsMultiplier: 'Multiplicador',
    sponsoredFormLabelProduct: 'Producto',
    sponsoredFormLabelSendNotications: 'Notificar a los usuarios',
    sponsoredFormLabelUseTeams: 'Restringir por equipo',
    sponsoredFormLabelTeams: 'Veces',
    sponsoredMessageRequiredStartDate: 'Fecha de inicio obligatoria',
    sponsoredMessageRequiredEndDate: 'Fecha final obligatoria',
    sponsoredMessageRequiredDescription: 'La descripción es obligatoria',
    sponsoredMessageMinPointsMiltiplier: 'Valor mínimo',
    sponsoredMessageRequiredPointsMultiplier: 'El multiplicador es obligatorio',
    sponsoredMessageRequiredSelectedProduct: 'No hay producto seleccionado',
    //TRADING-LIST
    tradingListTitle: 'Motor comercial',
    tradingListButtonAdd: 'Nuevo motor de negociación',
    tradingListTableHeaderName: 'Nombre',
    tradingListTableHeaderUsersAssociated: 'Qtd. Usuarios',
    //TRADING-FORM
    tradingFormTitle: 'Registro de motores comerciales',
    tradingFormButtonEdit: 'Actualizar el motor de comercio',
    tradingFormButtonNew: 'Crear motor de comercio',
    tradingFormButtonMinimumMargin: 'Margen mínimo artículo',
    tradingFormLabelTeam: 'Hora',
    tradingFormLabelMinimumMarginUser: 'Margen mínimo RCA',
    tradingFormLabelMinimumMarginOrder: 'Solicitud de margen mínima',
    tradingFormLabelMinimumMarginItem: 'Artículo mínimo de margen',
    tradingMessageMinMinimumMarginUser: 'Margen mínimo de valor incorrecto RCA',
    tradingMessageRequiredMinimumMarginUser: 'El margen mínimo de RCA es obligatorio',
    tradingMessageMinMinimumMarginOrder: 'Margen de valor incorrecto',
    tradingMessageRequiredMinimumMarginOrder: 'La solicitud de margen mínima es obligatoria',

    //CLIENT MODAL
    clientModalTitle: 'Detalles del cliente',
    clientModalTab1: 'Client',
    clientModalTab2: 'Recomendación',
    clientModalTab3: 'Histórico',
    clientModalTab4: 'Para navegar',
    clientModalTab5: 'Evaluaciones',
    clientModalFilterButton: 'Filtrar',
    clientModalDateRangeInvalid: 'La fecha final no puede ser anterior a la fecha inicial',

    //CLIENT FORM
    clientRatingForm: 'Evaluación',
    clientCommentForm: 'Comentario',
    clientCommentFormRequired: 'Se requiere comentario.',
    clientRatingFormRequired: 'La evaluación es obligatoria.',
    clientRatingFormEmpty: 'El cliente actualmente no tiene comentarios.',
    clientRatingFormCreatedMessage: 'Reseña creada con éxito.',

    // CLIENTS FILTER MODAL
    clientsFilterModalvisitOnMonday: 'Lunes',
    clientsFilterModalvisitOnTuesday: 'Martes',
    clientsFilterModalvisitOnWednesday: 'Miércoles',
    clientsFilterModalvisitOnThursday: 'Jueves',
    clientsFilterModalvisitOnFriday: 'Viernes',
    clientsFilterModalvisitOnSaturday: 'Sábado',
    clientsFilterModalvisitOnSunday: 'Domingo',
    clientsFilterModalVisitInput: 'Días de visita',
    clientsSearchModalFilterApplyDayFilters: 'Aplicar filtro de día',

    //ORDER
    orderTitle: 'Mis pedidos',
    orderButtonAdd: 'Nuevo Patrocinado',
    orderTableHeaderId: 'IDENTIFICACIÓN',
    orderTableHeaderOrderNumber: 'Orden',
    orderTableHeaderClient: 'Cliente',
    orderTableHeaderSubsidiary: 'Filial',
    orderTableHeaderOrderStatus: 'Estado',
    orderTableHeaderOrderTotal: 'Total',
    orderTableHeaderCreatedAt: 'Dt.creación',
    orderTableHeaderUpdatedAt: 'Dt.actualizar',

    orderFilterClient: 'Cliente',
    orderFilterTitle: 'Filtro de Pedido',
    orderFilterStatus: 'Estado',
    orderFilterPeriod: 'Período',
    orderFilterOrderType: 'Tipo de orden',
    orderFilterOrderExternalNumber: 'Número de pedido del ERP',
    orderFilterIsExternal: 'Solo pedidos externos (ERP)',
    orderFilterInvoiceNumber: 'Número de factura',

    orderFilterApply: 'Aplicar Filtros',

    //ORDER DETAIL
    orderDetailTitle: 'Orden',
    orderDetailLabelStatus: 'Estado',
    orderDetailLabelSubsidiary: 'Filial',
    orderDetailLabelShippingType: 'Flete',
    orderDetailLabelDate: 'Datos',
    orderDetailLabelClient: 'Cliente',
    orderDetailLabelPaymentOption: 'Pegeto',
    orderDetailLabelPaymentPlan: 'Pegeto',
    orderDetailLabelObservation: 'Observación',
    orderDetailLabelProduct: 'Producto',
    orderDetailLabelSoldPrice: 'Precio unitario',
    orderDetailLabelSoldQuantity: 'Cantidad',
    orderDetailLabelTotalItem: 'Precio total',
    orderDetailLabelExternalCode: 'Código',
    orderDetailLabelBrand: 'Marca',
    orderDetailLabelPaymentPlanGroup1Total: 'Ético',
    orderDetailLabelPaymentPlanGroup2Total: 'Total Genérico',
    orderDetailLabelTotal: 'Total',
    //ORDER STATUS
    orderStatusAll: 'Todos los estados',
    orderStatusWaitingApproval: 'Esperando aprobación',
    orderStatusBudget: 'Presupuesto',
    orderStatusProcessing: 'Procesando',
    orderStatusAccepted: 'Okey',
    orderStatusBilled: 'Facturado',
    orderStatusBlocked: 'Bloqueado',
    orderStatusWaitingPayment: 'En espera de pago',
    orderStatusPending: 'Colgante',
    orderStatusReleased: 'Publicado',
    orderStatusMounted: 'Montado',
    orderStatusPaid: 'Pago',
    orderStatusRejected: 'Rechazado',
    orderStatusError: 'Error',
    orderStatusCanceled: 'Cancelado',
    orderDownloadPDF: 'Descargar PDF',

    //ORDER MODAL DELETE
    orderModalDeleteMessage: '¿Está seguro de que desea eliminar el pedido?',

    //ORDER CHECKOUT PENDENCIES
    orderCheckoutRequiredAdditionalProductToKit:
      'El pedido requiere un producto adicional que no pertenece al mismo combo/kit',

    //ORDE CREATE
    orderCreateLabelClientEmptyRating: 'El cliente no tiene calificaciones, califíquelo antes de iniciar una venta.',
    orderCreateLabelClientRatingDeadline: 'El tiempo máximo para evaluar al cliente ha expirado.',
    orderCreateLabelPaymentPlanNoOptions: 'No se encontraron planes',

    //WORKING HOURS
    workingHoursPlaceholderIn: 'de',
    workingHoursPlaceholderTill: 'hasta',
    workingHoursLabelAlter: '¿Quieres configurar diferentes tiempos desde el valor predeterminado?',
    workingHoursLabelStartFirstShift: 'Mañana',
    workingHoursLabelEndFirstShift: 'Mañana fuera',
    workingHoursLabelStartSecondShift: 'Entrada Tarde',
    workingHoursLabelStartEndSecondShift: 'Después',
    //CONFIGURATION
    configurationTitle: 'Ajustes',
    configurationSectionSystemControls: 'Controles del sistema',
    configurationSectionSalesOrderParameters: 'Parámetros para la solicitud de venta',
    configurationSectionPayment: 'Pagos',
    configurationSectionProductPhotos: 'Fotos de productos',
    configurationSectionShipping: 'Flete',
    configurationSectionPointsAccelerator: 'Aceleración de puntos',
    configurationSectionTradingFinancialIncrease: 'Aumento financiero en márgenes del motor.',
    configurationSectionFactors: 'Factores',
    configurationSectionWorkingHours: 'Horario de trabajo',
    configurationButtonSave: 'Guardar configuración',
    configurationMessageSendImagens: 'Enviando imágenes ...',
    configurationMessageSuccessSendImagems: '¡Imágenes cargadas!',
    configurationMessageSuccess: '¡Configuración guardada!',
    configurationMessageErrorPayment: 'Complete los detalles del pago',
    configurationMessageErrorEmail: 'Complete los detalles del correo electrónico',
    configurationMessageErrorWhatsapp: 'Complete los datos de whatsapp',
    configurationMessageErrorWorkingHours: 'Complete sus horas de trabajo',
    configurationDefaultPriceTableCode: 'Código de tabla de precios predeterminado',
    configurationLabelAllowOrderDelete: 'Le permite eliminar el pedido',

    //CONFIGURATION-System Controls
    configurationLabelUseOrderModule: 'Utiliza fuerza de ventas',
    configurationLabelUseNegotiationEngine: 'Usa el motor de negociación',
    configurationLabelUseMedPromotions: 'Utiliza el control de la medicina',
    configurationLabelAllowMixedBonification: 'Usa bonificación mixta',
    configurationLabelAcceptBlockedSale: 'Acepta la venta bloqueada',
    configurationLabelAcceptDiscountDelivery: 'Acepta descuento de entrega',
    configurationLabelAcceptSaleWithoutStock: 'Acepta venta sin stock',
    configurationLabelAcceptNegativeBalance: 'Acepta la venta negativa',
    configurationLabelTaxation: 'Acepta impuestos',
    configurationLabelDecimals: 'Casas decimales',
    //CONFIGURATION-Sales Order Parameters
    configurationLabelUseBonificationSale: 'Permite queventabonificada',
    configurationLabelUseShippingControl: 'Te permite seleccionar flete',
    configurationLabelAllowShippingEdit: 'Permitir editar el costo de envío manualmente',
    configurationLabelUseDefaultPaymentOption: 'Le permite cambiar el método de pago',
    configurationLabelAllowDiscountChanging: 'Le permite incluir el descuento',
    configurationLabelAllowComissionPromo: 'Le permite mostrar comisión',
    configurationLabelAllowInvoiceObservation: 'Te permite informar a nf observación',
    configurationLabelUseClientRatingOption: 'Permite evaluar al cliente',
    configurationLabelDeliveryByCityOption: 'Le permite seleccionar transportistas por ciudad',
    configurationLabelBlockOrderUnratedClientOption: 'Bloquear venta a cliente sin revisión',
    configurationLabelClientRatingDeadlineOption: 'Período máximo de evaluación del cliente',
    configurationLabelOnlyProductOnKitOption: 'Solo productos combinados/kit',

    //CONFIGURATION-Payment
    configurationLabelAllowPaymentLink: 'Usar el pago de enlace',
    //CONFIGURATION-Api
    configurationLabelIpPrimary: 'IP primario',
    configurationLabelIpSecondary: 'IP secundaria',
    configurationButtonTestConection: 'Conexión de prueba',
    configurationApiModalTitle: 'Prueba de conexión',
    configurationApiModalMessage: 'Mensaje',
    configurationApiModalMessageSuccess: 'Exitoso conectado',
    configurationApiModalButtonRetry: 'Intentar nuevamente',
    configurationApiModalButtonClose: 'Cerrar',
    //CONFIGURATION-Email
    configurationLabelPassword: 'Contraseña',
    configurationLabelPort: 'Porta smtp',
    configurationLabelAuthentication: 'Autenticación',
    //CONFIGURATION-Trading Financial Increase
    configurationLabelInitialTime: 'Comienzo',
    configurationLabelFinalTime: 'Fin',
    configurationLabelMarginIncrease: 'Margen',
    configurationButtonAddNewMargin: 'Añadir nuevo margen',
    //CONFIGURATION-Factors
    configurationLabelMinimumMargin: 'Margen mínimo',
    configurationLabelMaximumSalePercentage: 'Incremento máximo de ventas',
    configurationLabelRadiusVisit: 'Rayo',
    configurationLabelStayLength: 'Tiempo mínimo',
    configurationLabelConversionFactorGift: 'Factor de puntos',
    configurationLabelpointsFactorRewardValue: 'Factor de punto de recompensa',
    //NOTIFICAITON
    notificationTitle: 'Notificación',
    notificationLabelTitle: 'Título',
    notificationLabelShortMessage: 'Mensaje corto',
    notificationLabelSendToAll: 'Someterse a todos',
    notificationLabelUsers: 'Usuarios',
    notificationButtonSubmit: 'Enviar notificación',
    notificationNewNotifications: 'Notificaciones nuevas',
    notificationShowAll: 'Mostrar todas las notificaciones',
    notificationLabelSend: 'Enviar',
    notificationLabelList: 'Lista',

    //PRODUCT-DETAILS
    productDetailsLabelOriginalNumber: 'Número original',
    productDetailsLabelLastDetails: 'Último precio de compra',
    // PRODUCTS-LIST
    productsTitle: 'Productos',
    productsFilterTitle: 'Filtro de Producto',
    productsFilterLabelLocalizationItem: 'Subsidiaria',
    productsFilterLabelWithStock: 'Con Existencias',
    productsFilterLabelWithoutStock: 'Agotado',
    productsFilterQueryString: 'Búsqueda',
    productsFilterBrand: 'Marca',
    productsFilterButton: 'Filtros',
    productsFilterCode: 'Código',
    productsFilterBarCode: 'Cod. Barras',
    productsFilterName: 'Nombre',
    productsFilterApply: 'Aplicar Filtros',
    productsFilterStock: 'Inventario',
    productsFilterPrice: 'Precio',

    promotionFormLabelRequireAdditionalProductToKit: 'Requiere producto adicional al kit',

    //accountBalance
    AccountBalanceDetailsLabel: 'Saldo del vendedor',
    AccountBalanceDetailsLabelDiscount: 'Importe descontado',
    orderCreateCheckoutObservationAccountBalance: 'Observaciones de la cuenta corriente',
    orderCreateCheckoutInitialDateLabel: 'Fecha inicial',
    orderCreateCheckoutEndDateLabel: 'Fecha final',
    accountBalanceMenuLabel: 'Saldo CC',
    accountBalanceMenuStatementLabel: 'Extracto CC',
    accountBalanceMenuSectionTitle: 'Cuenta Corriente',
    accountBalancePreviousBalanceLabel: 'Saldo anterior',
    accountBalanceEmptyMessage: 'No se encontraron movimientos para el período seleccionado.',
    accountBalanceOrderNumberLabel: 'Nº de pedido',
    accountBalanceSearchButtonLabel: 'Buscar',
    accountBalanceLoadMoreLabel: 'Cargar más',
    accountBalanceLoadingMoreLabel: 'Cargando...',

    // Cart recommendations
    cartRecommendationPopupTitle: 'Productos recomendados para ti',
    cartRecommendationPopupSubtitle: 'Sugerencias basadas en el historial del cliente.',
    cartRecommendationPopupAddButton: 'Agregar',
    cartRecommendationPopupCloseButton: 'Cerrar',
    cartRecommendationPopupRetryButton: 'Actualizar lista',
    cartRecommendationPopupDisableButton: 'No quiero recomendaciones',
    cartRecommendationPopupEmpty: 'No hay recomendaciones disponibles por el momento.',
    cartRecommendationFloatingLabel: 'Recomendaciones',
    cartRecommendationFloatingTooltip: 'Abrir recomendaciones',
    cartRecommendationOpenButton: 'Ver Recomendaciones'
  }
};

export default SPANISH;
